import { render, staticRenderFns } from "./BankAccountsTable.vue?vue&type=template&id=77231612&scoped=true&"
import script from "./BankAccountsTable.vue?vue&type=script&lang=js&"
export * from "./BankAccountsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77231612",
  null
  
)

export default component.exports